/* Suprimal strip journey (sections/sp-timeline on pages without a product): steps the scene and timeline together.
   2026-10-30: 1 Peel (sachet peeled open in the air), 2 Place (strip carried into the mouth, starts to soften),
   3 Dissolve (dissolves, then the mouth closes into a big smile), 4 closing scene (smile, sun, sparkles).
   The mouth morphs between three shapes (shut, open, smile) kept on animate[data-mk] (data-shut / data-open / data-smile);
   everything else is CSS keyed to [data-stage]. Smoother version: longer, eased morphs; after the strip dissolves the mouth
   closes and flows into the smile in one continuous morph (open, shut, smile) instead of two separate moves. */
(function () {
  var DUR = [4200, 3800, 4600, 3600];
  var EASE = '.45 0 .25 1';
  function init(root) {
    if (!root || root.__sj) return;
    root.__sj = 1;
    var steps = [].slice.call(root.querySelectorAll('[data-sj-step]'));
    var n = steps.length;
    if (!n) return;
    var num = root.querySelector('[data-sj-num]');
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var auto = root.getAttribute('data-autoplay') === '1' && !reduce;
    var cur = 0, timer = null, on = false, seen = false, outro = false;
    var svg = root.querySelector('svg');
    var mk = [].slice.call(root.querySelectorAll('animate[data-mk]'));
    var mouthNow = root.getAttribute('data-mouth') || 'shut';
    var later = [];
    root.classList.add('is-js');
    if (auto) root.classList.add('is-auto');

    /* path: list of shapes starting with the current one, e.g. ['open', 'shut', 'smile']; times and splines as in SMIL */
    function play(path, dur, times, splines) {
      if (!mk.length) return;
      mk.forEach(function (a) {
        var v = path.map(function (k) { return a.getAttribute('data-' + k); });
        if (v.some(function (x) { return !x; })) return;
        a.setAttribute('values', v.join(';'));
        a.setAttribute('keyTimes', times);
        a.setAttribute('keySplines', splines);
        a.setAttribute('dur', dur);
        try { a.beginElement(); } catch (e) {}
      });
      mouthNow = path[path.length - 1];
      root.setAttribute('data-mouth', mouthNow);
    }
    function morph(to, instant, dur) {
      if (to === mouthNow && !instant) return;
      if (instant) play([to, to], '0.001s', '0;1', EASE);
      else play([mouthNow, to], dur || '0.8s', '0;1', EASE);
    }
    function clearLater() { later.forEach(clearTimeout); later = []; }
    function at(ms, fn) { later.push(setTimeout(fn, ms)); }

    /* the mouth for each scene: 1 resting shut, 2 opens for the strip, 3 closes after the strip is gone and smiles, 4 keeps the smile */
    function mouthFor(stage, still) {
      clearLater();
      if (still) { morph(stage === 1 ? 'shut' : stage === 2 ? 'open' : 'smile', true); return; }
      if (stage === 1) { if (mouthNow !== 'shut') at(100, function () { morph('shut', false, '0.9s'); }); }
      else if (stage === 2) at(250, function () { morph('open', false, '0.75s'); });
      else if (stage === 3) {
        if (mouthNow !== 'open') morph('open', mouthNow === 'smile', '0.6s');
        /* after the strip is gone: lips meet, then widen into the smile, as one movement */
        at(1500, function () { play(['open', 'shut', 'smile'], '1.6s', '0;.36;1', '.45 0 .6 .85;.3 .2 .2 1'); });
      } else morph('smile', false, '0.9s');
    }

    /* where the floating strip is in its bob, so the next step starts from there instead of jumping */
    function keepBob() {
      var b = root.querySelector('.sp-sj__fly .sp-sj__bob');
      if (!b) return;
      var m = /matrix\(([^)]+)\)/.exec(getComputedStyle(b).transform || '');
      var y = m ? parseFloat(m[1].split(',')[5]) || 0 : 0;
      root.style.setProperty('--sj-bob', y.toFixed(2) + 'px');
    }
    function set(k, replay) {
      var prev = root.getAttribute('data-stage');
      keepBob();
      cur = k;
      outro = false;
      if (prev) root.setAttribute('data-prev', prev); else root.removeAttribute('data-prev');
      if (replay) { root.removeAttribute('data-stage'); void root.offsetWidth; }
      var stage = Math.min(k, 3) + 1;
      root.setAttribute('data-stage', String(stage));
      root.style.setProperty('--sj-dur', (DUR[k] || 4200) + 'ms');
      steps.forEach(function (s, j) {
        s.classList.toggle('is-active', j === k);
        s.classList.toggle('is-done', j < k);
        var b = s.querySelector('button');
        if (b) b.setAttribute('aria-pressed', j === k ? 'true' : 'false');
      });
      if (num) num.textContent = (k < 9 ? '0' : '') + (k + 1);
      mouthFor(stage, reduce || !root.classList.contains('is-run'));
    }
    /* fewer than four steps: after the last one, play the closing scene (smile, sun) with every step done, then loop */
    function finale() {
      outro = true;
      root.setAttribute('data-prev', root.getAttribute('data-stage') || '');
      root.setAttribute('data-stage', '4');
      steps.forEach(function (s) {
        s.classList.remove('is-active');
        s.classList.add('is-done');
        var b = s.querySelector('button');
        if (b) b.setAttribute('aria-pressed', 'false');
      });
      mouthFor(4, reduce || !root.classList.contains('is-run'));
    }
    function schedule() {
      clearTimeout(timer);
      if (!auto || !on) return;
      timer = setTimeout(function () {
        if (!outro && n < 4 && cur === n - 1) finale(); else set((cur + 1) % n);
        schedule();
      }, outro ? DUR[3] : (DUR[cur] || 4200));
    }
    function pick(j) {
      if (j < 0 || j >= n) return;
      auto = false;
      root.classList.remove('is-auto');
      clearTimeout(timer);
      if (!seen) { seen = true; if (!reduce) root.classList.add('is-run'); }
      set(j, true);
    }
    root.__sjPick = pick;
    steps.forEach(function (s, j) { s.addEventListener('click', function () { pick(j); }); });

    if (!('IntersectionObserver' in window)) {
      on = seen = true;
      root.classList.add('is-on');
      if (!reduce) root.classList.add('is-run');
      set(0, true);
      schedule();
      return;
    }
    new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        on = x.isIntersecting;
        root.classList.toggle('is-on', on);
        if (svg && svg.pauseAnimations) { try { if (on) svg.unpauseAnimations(); else svg.pauseAnimations(); } catch (e) {} }
        if (on && !seen) {
          seen = true;
          if (!reduce) root.classList.add('is-run');
          set(0, true);
        }
        if (on) schedule(); else clearTimeout(timer);
      });
    }, { threshold: 0.3 }).observe(root);
  }
  function all() { [].forEach.call(document.querySelectorAll('[data-sp-sj]'), init); }
  all();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', all);
  document.addEventListener('shopify:block:select', function (e) {
    var li = e.target && e.target.closest ? e.target.closest('[data-sj-step]') : null;
    var root = li && li.closest('[data-sp-sj]');
    if (root && root.__sjPick) root.__sjPick([].indexOf.call(root.querySelectorAll('[data-sj-step]'), li));
  });
})();
